// extracted by mini-css-extract-plugin
module.exports = {"nameWrap":"TargetEmployeeBonus__nameWrap--2ghy6","name":"TargetEmployeeBonus__name--1rBTA","action":"TargetEmployeeBonus__action--1H_nB","list":"TargetEmployeeBonus__list--204wm"};